module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.completed) ? _c('md-list-item', [_c('md-icon', [_vm._v("cloud_upload")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.area.name))]), _vm._v(" "), (!_vm.hasStarted) ? _c('md-button', {
    staticClass: "md-accent md-raised",
    on: {
      "click": _vm.startArea
    }
  }, [_vm._v("INICIAR UPLOAD")]) : _vm._e(), _vm._v(" "), _c('md-list-expand', [_c('md-list', _vm._l((_vm.area.structures), function(item, key) {
    return _c('structure-sync-item', {
      key: item['.key'],
      attrs: {
        "areaStarted": _vm.hasStarted,
        "id": key,
        "name": item.name,
        "photos": item.photos,
        "status": item.status,
        "areaId": _vm.area.id,
        "itemId": item.id,
        "type": item.type
      },
      on: {
        "structureSynced": _vm.structureSyncHandler
      }
    })
  }), 1), _vm._v(" "), _c('md-list', _vm._l((_vm.area.vertices), function(item, key) {
    return _c('structure-sync-item', {
      key: item['.key'],
      attrs: {
        "id": key,
        "areaStarted": _vm.hasStarted,
        "name": item.name,
        "photos": item.photos,
        "status": item.status,
        "areaId": _vm.area.id,
        "itemId": item.id.toString(),
        "type": item.type
      },
      on: {
        "structureSynced": _vm.verticeSyncHandler
      }
    })
  }), 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-812b4558","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AreaSyncList.vue
// module id = 839
// module chunks = 1